type featureFlags = {
  // 3. add the enum value here
  prefetchSharedDrives: 'prefetchSharedDrives';
  showMobileManagementFilters: 'showMobileManagementFilters';
  showPaginatedSharedDrives: 'showPaginatedSharedDrives';
  indexMobileDevicesReact: 'indexMobileDevicesReact';
  indexUsersReact: 'indexUsersReact';
  indexGroupsReact: 'indexGroupsReact';
  drivePickerUIReact: 'drivePickerUIReact';
  driveLabelsRead: 'driveLabelsRead';
  driveLabelsOps: 'driveLabelsOps';
  driveLabelsQ4: 'driveLabelsQ4';
  vaultExportReact: 'vaultExportReact';
  enterpriseFeatureUpsellUiReact: 'enterpriseFeatureUpsellUiReact';
  gmailExportDeprecation: 'gmailExportDeprecation';
  rulesEnginev2UiReact: 'rulesEnginev2UiReact';
  vaultDecomAction: 'vaultDecomAction';
  uiEnhancementPhase2: 'uiEnhancementPhase2';
  supportAgentEnabled: 'supportAgentEnabled';
  groupsGovernanceBackend: 'groupsGovernanceBackend';
  commandDashboardUi: 'commandDashboardUi';
  decommissioningUiUpdate: 'decommissioningUiUpdate';
  slackIntegration: 'slackIntegration';
  newBulkOpUi: 'newBulkOpUi';
};

export type FeatureFlagName = keyof featureFlags;

export const isFeatureEnabled = (
  featureFlagName: FeatureFlagName,
  features: Record<string, boolean> | null
) => {
  if (!features) {
    return false;
  }

  if (features[featureFlagName]) {
    return features[featureFlagName];
  }

  return false;
};
